export class Prospect {
	static STATES: any[] = [
		{ value: "occupied", title: "Uthyrd", badge: "secondary" },
		{ value: "available", title: "Ledig", badge: "primary" },
		{ value: "deal", title: "Affär", badge: "success" },
		{ value: "rejected", title: "Avfärdad", badge: "dark" },
	];
}
